import { createStore } from 'vuex'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import * as actions from './actions'
import undoRedoPlugin from './undoRedoPlugin'

export default createStore({
  state,
  mutations,
  plugins:[undoRedoPlugin],
  actions,
})

